var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var VisibilityToggle_1;
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { observable } from '@slickdeals/durango/dist/javascript/decorators/observable';
import '../../scss/components/visibilityToggle.scss';
/** The name of the module */
export const name = 'VisibilityToggle';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-c-visibilityToggle";
    ClassNames["Visible"] = "bp-c-visibilityToggle--visible";
    ClassNames["Indicator"] = "bp-c-visibilityToggle_indicator";
})(ClassNames || (ClassNames = {}));
export var ObservableEvents;
(function (ObservableEvents) {
    ObservableEvents["Toggled"] = "visibilityToggled";
})(ObservableEvents || (ObservableEvents = {}));
let VisibilityToggle = VisibilityToggle_1 = class VisibilityToggle {
    constructor(options) {
        this.triggerStrategy = options.triggerStrategy;
        this.targetStrategy = options.targetStrategy;
        this.indicatorStrategy = options.indicatorStrategy;
        this.stopPropagation = options.stopPropagation || false;
        // Alias event handler for de-registering event handlers later
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.init();
    }
    /**
     * Create an VisibilityToggle instance
     */
    static create(options) {
        return new VisibilityToggle_1(options);
    }
    /**
     * Performs any necessary initialization for the component
     */
    init() {
        const triggerElement = this.triggerStrategy.getTriggerElement();
        triggerElement.addEventListener('click', this.toggleVisibility);
    }
    /**
     * Perform any required cleanup to properly destroy the component
     */
    destroy() {
        this.triggerStrategy.getTriggerElement().removeEventListener('click', this.toggleVisibility);
        this.triggerStrategy.destroy();
        if (this.indicatorStrategy) {
            this.indicatorStrategy.destroy();
        }
    }
    /**
     * Determines if visibilityToggle should show/hide target
     */
    toggleVisibility(event) {
        if (this.stopPropagation) {
            event.stopPropagation();
        }
        this.triggerStrategy.toggleVisibility();
        this.targetStrategy.toggleVisibility();
        if (this.indicatorStrategy && typeof this.indicatorStrategy.toggleIcon === 'function') {
            this.indicatorStrategy.toggleIcon();
        }
        const visibilityData = {
            triggerVisibility: this.triggerStrategy.getVisibilityState(),
            targetVisibility: this.targetStrategy.getVisibilityState(),
        };
        // Dispatches a visibility toggled event with the visibility of both the trigger and target
        this.notify(visibilityData, ObservableEvents.Toggled);
    }
};
VisibilityToggle = VisibilityToggle_1 = __decorate([
    injectable(name),
    observable
], VisibilityToggle);
export default VisibilityToggle;
